import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Field, reduxForm } from 'redux-form/immutable'
import { injectIntl } from 'react-intl'
import bowser from 'bowser'

import { FIELD, LOCALE_PREFIX } from './constants'

import Input from '../../../../components/Form/components/Input'
import Button from '../../../../components/Form/components/Button'

import './style.scss'

const browser = bowser.getParser(typeof window !== 'undefined' ? window.navigator.userAgent : 'UA')

const validate = (values = {}, props) => {
    const errors = {}

    // required
    if (!values.get(FIELD.USERNAME))
        errors[FIELD.USERNAME] = props.intl.formatMessage({ id: `${LOCALE_PREFIX}.error.username` })
    if (!values.get(FIELD.PASSWORD))
        errors[FIELD.PASSWORD] = props.intl.formatMessage({ id: `${LOCALE_PREFIX}.error.password` })

    return errors
}

@injectIntl
@reduxForm({ form: 'LoginForm', validate })
export default class LoginForm extends Component {
    static propTypes = {
        autofill: PropTypes.func.isRequired,
        error: PropTypes.string,
        handleSubmit: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
        invalid: PropTypes.bool.isRequired,
        pristine: PropTypes.bool.isRequired,
        submitting: PropTypes.bool.isRequired,
    }

    onHiddenInputChange = (_e) => {
        const { autofill } = this.props

        autofill(_e.target.name, _e.target.value)
    }

    render() {
        const { error, invalid, handleSubmit, pristine, submitting, intl } = this.props

        return (
            <Form className={'login-form'} onSubmit={handleSubmit}>
                {browser.is('Chrome') && (
                    <div style={{ display: 'none' }}>
                        <input type={'text'} name={'username'} onChange={this.onHiddenInputChange} />
                        <input type={'password'} name={'password'} onChange={this.onHiddenInputChange} />
                    </div>
                )}
                <div>
                    <Field
                        name={FIELD.USERNAME}
                        component={Input}
                        placeholder={intl.formatMessage({ id: `${LOCALE_PREFIX}.username` })}
                        disabled={submitting}
                        showError={false}
                        showLabel={false}
                        showErrorBorder
                    />
                </div>
                <div>
                    <Field
                        name={FIELD.PASSWORD}
                        component={Input}
                        type={'password'}
                        placeholder={intl.formatMessage({ id: `${LOCALE_PREFIX}.password` })}
                        disabled={submitting}
                        showError={false}
                        showLabel={false}
                        showErrorBorder
                    />
                </div>
                <div className={'submit-button'}>
                    <Button
                        text={intl.formatMessage({ id: `${LOCALE_PREFIX}.button` })}
                        disabled={(invalid && !error) || pristine || submitting}
                        type={'submit'}
                    />
                </div>
            </Form>
        )
    }
}
